import { render, staticRenderFns } from "./SurveyRegist.vue?vue&type=template&id=4fc65e16&scoped=true"
import script from "./SurveyRegist.vue?vue&type=script&lang=js"
export * from "./SurveyRegist.vue?vue&type=script&lang=js"
import style0 from "./SurveyRegist.vue?vue&type=style&index=0&id=4fc65e16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc65e16",
  null
  
)

export default component.exports